module.exports = __webpack_public_path__ + "img/1.fd788463.png";